import { CoreConfig } from '@movilidad/app-core/config';

import { BUILD_INFO } from './build-info';
import { environment } from './environment';

/**
 * Lo que @movilidad/app-core lee del ambiente (TEC-293). Vive junto a `environment.ts` para que el
 * `fileReplacements` de production (y el reescrito de `write-app-env.mjs`) le lleguen igual que antes.
 */
export const coreConfig: CoreConfig = {
  production: environment.production,
  version: environment.version,
  commitHash: BUILD_INFO.commitHash,
  apiBaseUrl: environment.apiBaseUrl,
  tokenKey: environment.tokenKey,
  cryptoKey: environment.cryptoKey,
  storagePrefix: environment.storagePrefix,
  storageEncryption: environment.storageEncryption,
  pusher: environment.pusher,
};
